export enum MirrorInventoryFromParent {
  YES = 1,
  NO = 0,
}

export enum ProductStatus {
  ACTIVE = 1,
  DELETED = -2,
}
